"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Stack_1 = __importDefault(require("../Stack"));
const Card_1 = __importDefault(require("../Card"));
const icons_1 = require("../../icons");
const selectableCard_module_scss_1 = __importDefault(require("./selectableCard.module.scss"));
const SelectableCard = (_a) => {
    var { children, selected } = _a, cardProps = __rest(_a, ["children", "selected"]);
    return ((0, jsx_runtime_1.jsx)(Card_1.default, Object.assign({ size: "xs", className: selectableCard_module_scss_1.default.card }, cardProps, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, { layout: "horizontal", justify: "space-between", align: "center", children: [children, (0, jsx_runtime_1.jsx)(icons_1.CheckCircleIcon, { color: selected ? 'var(--color-white)' : 'var(--color-better-blush)', backgroundColor: selected ? 'var(--color-really-red)' : 'var(--color-better-blush)' })] }) })));
};
exports.default = SelectableCard;
